import React from "react";

export const Spinner = () => (
  <div className="animate-spin h-8 w-8 border-4 border-slate-300 rounded-full border-t-transparent" />
);
